import TextReportGenerator from "../TextReportGenerator";
import ReportData from "../../ReportData";
import { saveClassByClassNameDecorator } from "../../../../shared/utils/classNameToConstructor";
import { DisplayedField } from "../../DisplayedField";

const DEFAULT_VERSION = "1";

const TITLE: string = "ClearVoyage Delivery Report";

const FIELDS: DisplayedField[] = [
  { fieldType: "IMONumber", required: true },
  { fieldType: "NamedLocation", required: true },
  { fieldType: "ReportDate", required: true },
  { fieldType: "ROBItems", required: true },
  { fieldType: "Remarks", required: false },
];

@saveClassByClassNameDecorator()
class ClearVoyageDeliveryReportGenerator extends TextReportGenerator {
  public constructor() {
    super(TITLE, FIELDS, DEFAULT_VERSION);
  }

  getReportText(_data: ReportData, _version: string | undefined): string {
    return "";
  }
}

export default ClearVoyageDeliveryReportGenerator;
